import React from 'react';

// Node Types
import {
  SectionComponent,
  FluidImage as ImageType,
} from '@codersclan/gatsby-theme-airfleet/src/@types';

// Types
import { CTA } from '../../@types/cta';
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';

// Components
import HeroV2Component from '../../components/heroV2';

interface HeroV2Props extends Section {
  title: { title: string };
  subhead: { text: string };
  pardotForm?: {
    pardotEmbedUrl?: string;
  };
  featuredTitle: { text: string };
  featuredBodyText: { text: string };
  featuredImage: {
    alternativeText: string;
    image?: ImageType;
  };
  ctaText: { text: string };
  cta: CTA;
  ctaReadMore?: CTA;
}

const HeroV2: SectionComponent<HeroV2Props> = React.memo(
  ({
    title,
    subhead,
    pardotForm,
    featuredTitle,
    featuredBodyText,
    featuredImage,
    ctaText,
    ctaReadMore,
    cta,
  }) => (
    <>
      <HeroV2Component
        title={title.title}
        subtitle={subhead.text}
        cardTitle={featuredTitle.text}
        cardSubtitle={featuredBodyText.text}
        cardImage={featuredImage.image}
        cardCta={ctaReadMore}
        signUp={{
          text: ctaText.text,
          pardotForm,
          cta,
        }}
      />
    </>
  ),
);

export default HeroV2;
